'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/core-js/object/define-property');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _defineProperty4 = require('babel-runtime/helpers/defineProperty');

var _defineProperty5 = _interopRequireDefault(_defineProperty4);

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

var _uniq = require('lodash/uniq');

var _uniq2 = _interopRequireDefault(_uniq);

var _Session = require('./Session');

var _Session2 = _interopRequireDefault(_Session);

var _QuerySet = require('./QuerySet');

var _QuerySet2 = _interopRequireDefault(_QuerySet);

var _fields = require('./fields');

var _constants = require('./constants');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getByIdQuery(modelInstance) {
    var modelClass = modelInstance.getClass();
    return {
        table: modelClass.modelName,
        clauses: [{
            type: _constants.FILTER,
            payload: (0, _defineProperty5.default)({}, modelClass.idAttribute, modelInstance.getId())
        }]
    };
}

var Model = function () {
    function Model(props) {
        (0, _classCallCheck3.default)(this, Model);

        this._initFields(props);
    }

    Model.prototype._initFields = function _initFields(props) {
        var _this = this;

        this._fields = (0, _assign2.default)({}, props);

        (0, _forOwn2.default)(props, function (fieldValue, fieldName) {
            if (!(fieldName in _this)) {
                (0, _defineProperty3.default)(_this, fieldName, {
                    get: function get() {
                        return _this._fields[fieldName];
                    },
                    set: function set(value) {
                        return _this.set(fieldName, value);
                    },
                    configurable: true,
                    enumerable: true
                });
            }
        });
    };

    Model.toString = function toString() {
        return 'ModelClass: ' + this.modelName;
    };

    Model.options = function options() {
        return {};
    };

    Model._getTableOpts = function _getTableOpts() {
        if (typeof this.backend === 'function') {
            (0, _utils.warnDeprecated)('Model.backend is deprecated. Please rename to .options');
            return this.backend();
        } else if (this.backend) {
            (0, _utils.warnDeprecated)('Model.backend is deprecated. Please rename to .options');
            return this.backend;
        } else if (typeof this.options === 'function') {
            return this.options();
        }
        return this.options;
    };

    Model.markAccessed = function markAccessed(ids) {
        this.session.markAccessed(this.modelName, ids);
    };

    Model.markFullTableScanned = function markFullTableScanned() {
        this.session.markFullTableScanned(this.modelName);
    };

    Model.connect = function connect(session) {
        if (!(session instanceof _Session2.default)) {
            throw Error('A model can only connect to a Session instance.');
        }
        this._session = session;
    };

    Model.getQuerySet = function getQuerySet() {
        var QuerySetClass = this.querySetClass;
        return new QuerySetClass(this);
    };

    Model.invalidateClassCache = function invalidateClassCache() {
        this.isSetUp = undefined;
        this.virtualFields = {};
    };

    Model.all = function all() {
        return this.getQuerySet();
    };

    Model.prototype._refreshMany2Many = function _refreshMany2Many(relations) {
        var _this2 = this;

        var ThisModel = this.getClass();
        var fields = ThisModel.fields,
            virtualFields = ThisModel.virtualFields;


        (0, _keys2.default)(relations).forEach(function (name) {
            var reverse = !fields.hasOwnProperty(name);
            var field = virtualFields[name];
            var values = relations[name];

            var normalizedNewIds = values.map(_utils.normalizeEntity);
            var uniqueIds = (0, _uniq2.default)(normalizedNewIds);

            if (normalizedNewIds.length !== uniqueIds.length) {
                throw new Error('Found duplicate id(s) when passing "' + normalizedNewIds + '" to ' + ThisModel.modelName + '.' + name + ' value');
            }

            var throughModelName = field.through || (0, _utils.m2mName)(ThisModel.modelName, name);
            var ThroughModel = ThisModel.session[throughModelName];

            var fromField = void 0;
            var toField = void 0;

            if (!reverse) {
                var _field$throughFields = field.throughFields;
                fromField = _field$throughFields.from;
                toField = _field$throughFields.to;
            } else {
                var _field$throughFields2 = field.throughFields;
                toField = _field$throughFields2.from;
                fromField = _field$throughFields2.to;
            }

            var currentIds = ThroughModel.filter(function (through) {
                return through[fromField] === _this2[ThisModel.idAttribute];
            }).toRefArray().map(function (ref) {
                return ref[toField];
            });

            var diffActions = (0, _utils.arrayDiffActions)(currentIds, normalizedNewIds);

            if (diffActions) {
                var idsToDelete = diffActions.delete;
                var idsToAdd = diffActions.add;
                if (idsToDelete.length > 0) {
                    var _name;

                    (_name = _this2[name]).remove.apply(_name, (0, _toConsumableArray3.default)(idsToDelete));
                }
                if (idsToAdd.length > 0) {
                    var _name2;

                    (_name2 = _this2[name]).add.apply(_name2, (0, _toConsumableArray3.default)(idsToAdd));
                }
            }
        });
    };

    Model.create = function create(userProps) {
        var _this3 = this;

        var props = (0, _assign2.default)({}, userProps);

        var m2mRelations = {};

        var declaredFieldNames = (0, _keys2.default)(this.fields);
        var declaredVirtualFieldNames = (0, _keys2.default)(this.virtualFields);

        declaredFieldNames.forEach(function (key) {
            var field = _this3.fields[key];
            var valuePassed = userProps.hasOwnProperty(key);
            if (!(field instanceof _fields.ManyToMany)) {
                if (valuePassed) {
                    var value = userProps[key];
                    props[key] = (0, _utils.normalizeEntity)(value);
                } else if (field.getDefault) {
                    props[key] = field.getDefault();
                }
            } else if (valuePassed) {
                m2mRelations[key] = userProps[key];
                delete props[key];
            }
        });

        declaredVirtualFieldNames.forEach(function (key) {
            if (!m2mRelations.hasOwnProperty(key)) {
                var field = _this3.virtualFields[key];
                if (userProps.hasOwnProperty(key) && field instanceof _fields.ManyToMany) {
                    m2mRelations[key] = userProps[key];
                    delete props[key];
                }
            }
        });

        var newEntry = this.session.applyUpdate({
            action: _constants.CREATE,
            table: this.modelName,
            payload: props
        });

        var ModelClass = this;
        var instance = new ModelClass(newEntry);
        instance._refreshMany2Many(m2mRelations);
        return instance;
    };

    Model.upsert = function upsert(userProps) {
        var idAttr = this.idAttribute;
        if (userProps.hasOwnProperty(idAttr) && this.hasId(userProps[idAttr])) {
            var model = this.withId(userProps[idAttr]);
            model.update(userProps);
            return model;
        }

        return this.create(userProps);
    };

    Model.withId = function withId(id) {
        var ModelClass = this;
        var rows = this._findDatabaseRows((0, _defineProperty5.default)({}, ModelClass.idAttribute, id));
        if (rows.length === 0) {
            throw new Error(ModelClass.modelName + ' instance with id ' + id + ' not found');
        }

        return new ModelClass(rows[0]);
    };

    Model.hasId = function hasId(id) {
        var rows = this._findDatabaseRows((0, _defineProperty5.default)({}, this.idAttribute, id));
        return rows.length === 1;
    };

    Model._findDatabaseRows = function _findDatabaseRows(lookupObj) {
        var ModelClass = this;
        return ModelClass.session.query({
            table: ModelClass.modelName,
            clauses: [{
                type: _constants.FILTER,
                payload: lookupObj
            }]
        }).rows;
    };

    Model.get = function get(lookupObj) {
        var ModelClass = this;

        var rows = this._findDatabaseRows(lookupObj);

        if (rows.length === 0) {
            throw new Error('Model instance not found when calling get method');
        } else if (rows.length > 1) {
            throw new Error('Expected to find a single row in Model.get. Found ' + rows.length + '.');
        }

        return new ModelClass(rows[0]);
    };

    Model.prototype.getClass = function getClass() {
        return this.constructor;
    };

    Model.prototype.getId = function getId() {
        return this._fields[this.getClass().idAttribute];
    };

    Model.prototype.toString = function toString() {
        var _this4 = this;

        var ThisModel = this.getClass();
        var className = ThisModel.modelName;
        var fieldNames = (0, _keys2.default)(ThisModel.fields);
        var fields = fieldNames.map(function (fieldName) {
            var field = ThisModel.fields[fieldName];
            if (field instanceof _fields.ManyToMany) {
                var ids = _this4[fieldName].toModelArray().map(function (model) {
                    return model.getId();
                });
                return fieldName + ': [' + ids.join(', ') + ']';
            }
            var val = _this4._fields[fieldName];
            return fieldName + ': ' + val;
        }).join(', ');
        return className + ': {' + fields + '}';
    };

    Model.prototype.equals = function equals(otherModel) {
        return (0, _utils.objectShallowEquals)(this._fields, otherModel._fields);
    };

    Model.prototype.set = function set(propertyName, value) {
        this.update((0, _defineProperty5.default)({}, propertyName, value));
    };

    Model.prototype.update = function update(userMergeObj) {
        var ThisModel = this.getClass();
        var mergeObj = (0, _assign2.default)({}, userMergeObj);

        var fields = ThisModel.fields,
            virtualFields = ThisModel.virtualFields;

        var m2mRelations = {};

        for (var mergeKey in mergeObj) {
            var isRealField = fields.hasOwnProperty(mergeKey);

            if (isRealField) {
                var field = fields[mergeKey];

                if (field instanceof _fields.ForeignKey || field instanceof _fields.OneToOne) {
                    mergeObj[mergeKey] = (0, _utils.normalizeEntity)(mergeObj[mergeKey]);
                } else if (field instanceof _fields.ManyToMany) {
                    m2mRelations[mergeKey] = mergeObj[mergeKey];
                    delete mergeObj[mergeKey];
                }
            } else if (virtualFields.hasOwnProperty(mergeKey)) {
                var _field = virtualFields[mergeKey];
                if (_field instanceof _fields.ManyToMany) {
                    m2mRelations[mergeKey] = mergeObj[mergeKey];
                    delete mergeObj[mergeKey];
                }
            }
        }

        this._initFields((0, _assign2.default)({}, this._fields, mergeObj));
        this._refreshMany2Many(m2mRelations);

        ThisModel.session.applyUpdate({
            action: _constants.UPDATE,
            query: getByIdQuery(this),
            payload: mergeObj
        });
    };

    Model.prototype.refreshFromState = function refreshFromState() {
        this._initFields(this.ref);
    };

    Model.prototype.delete = function _delete() {
        this._onDelete();
        this.getClass().session.applyUpdate({
            action: _constants.DELETE,
            query: getByIdQuery(this)
        });
    };

    Model.prototype._onDelete = function _onDelete() {
        var _getClass = this.getClass(),
            virtualFields = _getClass.virtualFields;

        for (var key in virtualFields) {
            var field = virtualFields[key];
            if (field instanceof _fields.ManyToMany) {
                this[key].clear();
            } else if (field instanceof _fields.ForeignKey) {
                var relatedQs = this[key];
                if (relatedQs.exists()) {
                    relatedQs.update((0, _defineProperty5.default)({}, field.relatedName, null));
                }
            } else if (field instanceof _fields.OneToOne) {
                if (this[key] !== null) {
                    this[key][field.relatedName] = null;
                }
            }
        }
    };

    Model.prototype.getNextState = function getNextState() {
        throw new Error('Model.prototype.getNextState is removed. See the 0.9 ' + 'migration guide on the GitHub repo.');
    };

    (0, _createClass3.default)(Model, [{
        key: 'ref',
        get: function get() {
            var ModelClass = this.getClass();

            return ModelClass._findDatabaseRows((0, _defineProperty5.default)({}, ModelClass.idAttribute, this.getId()))[0];
        }
    }], [{
        key: '_sessionData',
        get: function get() {
            if (!this.session) return {};
            return this.session.getDataForModel(this.modelName);
        }
    }, {
        key: 'idAttribute',
        get: function get() {
            return this.session.db.describe(this.modelName).idAttribute;
        }
    }, {
        key: 'session',
        get: function get() {
            return this._session;
        }
    }, {
        key: 'query',
        get: function get() {
            return this.getQuerySet();
        }
    }]);
    return Model;
}();

Model.fields = {
    id: (0, _fields.attr)()
};
Model.virtualFields = {};
Model.querySetClass = _QuerySet2.default;

exports.default = Model;